import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend, Legend);

function ManufacturerStates({ products }) {
  const manufacturerArr = products.map((item) => {
    return item.manufacturer;
  });
  console.log(">>>>", manufacturerArr);
  const data = {
    labels: manufacturerArr.filter(
      (item, ind, arr) => manufacturerArr.indexOf(item) === ind
    ),
    datasets: [
      {
        label: "# of Votes",
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderColor: ["#ffff", "#ffff", "#ffff", "#ffff", "#ffff", "#ffff"],
        borderWidth: 1,
      },
    ],
  };
  return <Pie data={data} />;
}

export default ManufacturerStates;
